import { KimLhcService } from '@/infra/services/kim-lhc';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GetVideoInfoParams {
	company_id: string;
	organization_id: string;
	file_id?: string;
}

const Service = KimLhcService.getInstance();

export const useGetVideoInfo = (params: GetVideoInfoParams) => {
    return useQuery({
        queryKey: [QUERY_KEYS.GET_VIDEO_INFO, params],
        queryFn: () => Service.getVideoInfo(params),
        enabled: !!params.company_id && !!params.organization_id && !!params.file_id
    });
}